// extracted by mini-css-extract-plugin
module.exports = {"kind-dropdown-container":"KindDropDown_kind-dropdown-container__1KOKI"};